export const ANALYTICS_SCHEDULER_EVENTS = {
  BOOKING_BROWSER_DETAILS: 'Booking Browser Details',
  BOOKING_UNSUPPORTED_BROWSER_DETECTED: 'Booking Unsupported Browser Detected',
  MEETING_LINK_VISITED: 'Meeting Link Visited',
  MEETING_SLOT_UNAVAILABLE: 'Meeting Slot Unavailable',
  NOTIFY_HOST_SUBMITTED: 'Notify Host Submitted',
  CANCEL_MEETING_INITIATED: 'Cancel Meeting Initiated',
  CANCEL_MEETING_CONFIRMED: 'Cancel Meeting Confirmed',
  RESCHEDULE_MEETING_INITIATED: 'Reschedule Meeting Initiated',
  RESCHEDULE_CONFIRMED: 'Reschedule Confirmed',
  TIME_SLOT_SELECTED: 'Time Slot Selected',
  BOOKING_ERROR: 'Booking Error',
  BOOKING_CONFIRMED: 'Booking Confirmed',
} as const;
